// extracted by mini-css-extract-plugin
export default {"wrapper":"Slider_wrapper__L2vRC","label":"Slider_label__FrKPA","slider":"Slider_slider__IxNGF","value":"Slider_value__tp8sw"};